<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton class="inline-flex w-full justify-between gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
        <template v-if="!modelValue">
          <slot name="default" />
        </template>
        <!-- <tw-button-badge v-if="modelValue" variant="blue" class="relative">
          {{ label }}
        </tw-button-badge> -->
        {{ label }}
        <ChevronDownIcon v-if="!noDropdownIcon" class="-mr-1 h-5 w-5 text-gray-400 float-right" aria-hidden="true" />
      </MenuButton>
    </div>
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <MenuItems class="absolute left-0 z-[1000] w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div class="py-1">
          <MenuItem v-for="(option, index) in options" :key="'tw-key-option-' + index + '-' + id" v-slot="{ active }" @click="selectedOption(index)">
            <a :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-900',modelValue === option? 'bg-green-50':'', 'block px-4 py-2 text-sm']">
              <icon v-if="modelValue === option" icon="check" class="mr-2" />  {{ labelKey? option[labelKey]: $filters.formatString(option) }}
            </a>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import twSelectFieldMixin from '@/mixins/twSelectFieldMixin.js'
import { defineProps, defineModel, computed } from 'vue'
import TwButtonBadge from '@/components/generic/tw-button-badge.vue'

const props = defineProps(twSelectFieldMixin.props)
const emit = defineEmits(['update:modelValue'])
const model = defineModel({
  type: [String, Number, Object],
})

const selectedOption = (optionIndex) => {
  if(optionIndex > -1) {
    model.value = props.valueKey ? props.options[optionIndex][props.valueKey] : props.options[optionIndex]
  }
  else {
    model.value = null
  }
  // console.log('emitting update:modelValue', props.options[optionIndex])
  emit('update:modelValue', props.options[optionIndex])
}

const label = computed(() => {
  if(model.value !== null) {
    const selected = props.options.find(option => props.valueKey ? option[props.valueKey] === model.value[props.valueKey] : option === model.value)
    return selected ? (props.labelKey ? selected[props.labelKey] : selected) : null
  }
  return props.label || 'Select an option'
})

</script>
